<template>
  <Menubar
    v-if="renderLogoNav"
    class="shadow-lg !w-16 !h-16 !rounded-full !p-0 flex items-center justify-center !fixed top-2 left-1/2 transform -translate-x-1/2 z-50"
  >
    <template #start>
      <a
        :href="UnifyWebsiteURL"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Unify America (opens in new tab)"
        class="cursor-pointer w-10 h-10 rounded-full flex items-center justify-center"
      >
        <ImageComponent
          :src="unifyWhiteLogo"
          alt=""
        />
      </a>
    </template>
  </Menubar>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useRouter } from 'vue-router';
import unifyWhiteLogo from '@/assets/images/unifyAmericaLogos/UA-Big U Symbol White.png';
import { UNIFY_AMERICA_URLS } from '@/constants';

const router = useRouter();
const renderLogoNav = computed(() => router.currentRoute.value.meta.renderLogoNav === true);
const UnifyWebsiteURL = UNIFY_AMERICA_URLS.CIVIC_GYM;

</script>

<style scoped>
/* Additional styles for better visual separation */
#floating-nav {
  backdrop-filter: blur(10px);
  background-color: rgba(255, 255, 255, 0.95);
}

/* Ensure the navigation doesn't interfere with page content */
#floating-nav-container + * {
  margin-top: 80px; /* Adjust based on nav height */
}

/* The Menubar renders an empty root list as a second flex child beside the logo, and the bar's
   flex gap then nudges the only visible child ~4px left of centre. Drop it so the logo sits
   dead-centre in the circle. */
:deep(.p-menubar-root-list) {
  display: none;
}

/* Force rounded corners on all MenuBar item states - comprehensive targeting */
:deep(.p-menubar-item-link),
:deep(.p-menubar-item-link:hover),
:deep(.p-menubar-item-link:focus),
:deep(.p-menubar-item-link:active),
:deep(.p-menubar-item-content),
:deep(.p-menubar-item-content:hover),
:deep(.p-menubar-item-content:focus),
:deep(.p-menubar-item),
:deep(.p-menubar-item:hover),
:deep(.p-menubar-item:focus) {
  border-radius: 9999px !important;
}

/* Target any pseudo-elements that might be creating backgrounds */
:deep(.p-menubar-item-link::before),
:deep(.p-menubar-item-link::after),
:deep(.p-menubar-item-content::before),
:deep(.p-menubar-item-content::after) {
  border-radius: 9999px !important;
}

/* Set Aileron font for Avatar text */
:deep(.p-avatar .p-avatar-text) {
  font-family: var(--font-family-heading) !important;
  font-weight: bold !important;
}
</style>
